
export const characteristicUuid = "0000ff01-0000-1000-8000-00805f9b34fb"
export const characteristic2Uuid = "0000ff02-0000-1000-8000-00805f9b34fb"
export const serviceUuid = "0000ff00-0000-1000-8000-00805f9b34fb"
const responseTerminator = 0x0d0a;

export const getResponseCommand = (value) => {
  if (!value || value.byteLength < 4) return null;
  const view = value instanceof DataView
    ? value
    : new DataView(value.buffer, value.byteOffset, value.byteLength);
  return view.byteLength === 7 ? view.getUint8(3) : view.getUint8(2);
}

export const packCommand = (cmd, direction=1, args=[]) => {
  return new Uint8Array([0xff, 0x55, 6 + args.length, 0, direction, cmd, ...args]);
}
export class SGUAI {



  get connected() {
    return this?.device?.gatt?.connected;
  }

  constructor() {
    this.queue = [];
    this.inQueue = false;
    this.autoRefresh = false;
    this.slices = [];
    this.responses = {};
    this.responseCallback = {};
    this.refreshInterval = setInterval(async () => {
      if (this.connected && this.autoRefresh) {
        await this.refresh();
      }
    }, 1000 * 30);
  }


  setConnected = () => {

  }
  setCommand = () => {
  }
  disconnectionCallback = () => {
    console.log("dummy");
  }


  async discovery() {
    if (!navigator.bluetooth) {
      throw Error("Web Bluetooth is not available in this browser");
    }
    const options = {
      filters: [{ namePrefix: "SGUAI-" }],
      optionalServices: [serviceUuid]
    };
    return await navigator.bluetooth.requestDevice(options);
  }

  async resolveQueue() {
    if (this.inQueue) return;
    this.inQueue = true;
    try {
      while(this.queue.length > 0 && this.connected) {
        const item = this.queue.shift();
        this.setCommand({command: item.value, direction: ">"});
        try {
          await this.characteristic.writeValue(item.value);
          item.resolve();
        } catch (error) {
          item.reject(error);
        }
      }
    } finally {
      this.inQueue = false;
    }
  }

  async enqueueWrite(value) {
    if (!this.connected) throw Error("Device not connected");
    const pending = new Promise((resolve, reject) => {
      this.queue.push({value, resolve, reject});
    });
    this.resolveQueue();
    return pending;
  }

  clearQueue(error = Error("Device disconnected")) {
    this.queue.splice(0).forEach((item) => item.reject(error));
  }

  async sendCommand(cmd, direction, args) {
    if (!this.characteristic || !this.connected) {
      throw Error("Device not connected");
    }
    const _packed = packCommand(cmd, direction, args);
    return await this.enqueueWrite(_packed);
  }

  async send(cmd, args) {
    if (!this.characteristic || !this.connected) {
      throw Error("Device not connected");
    }
    const _packed = packCommand(cmd, 2, args);
    return await this.enqueueWrite(_packed);
  }

  async readByCallback(cmd, args, callback) {
    if (!this.characteristic || !this.connected) {
      throw Error("Device not connected")
    }
    const _packed = packCommand(cmd, 1, args);
    this.responseCallback[cmd] = callback;
    await this.enqueueWrite(_packed);
  }

  async read(cmd, args = []) {
    if (!this.characteristic || !this.connected) {
      throw Error("Device not connected")
    }
    const _packed = packCommand(cmd, 1, args);
    await this.enqueueWrite(_packed);
    const response = await this.characteristic2.readValue();
    if (getResponseCommand(response) === cmd) this.handleFrame(response);
    return this.responses[cmd] ?? response;
  }

  async syncTime() {
    // 04 635144e5 00 0320
    const buf = new ArrayBuffer(7);
    const dv = new DataView(buf);
    dv.setUint32(0, Math.floor(Date.now() / 1000));
    const tzOffset = new Date().getTimezoneOffset() * 10 / 6;
    dv.setInt8(4, tzOffset > 0 ? 1 : 0);
    dv.setInt16(5, Math.abs(tzOffset));

    await this.send(0x4, new Uint8Array(buf));
  }

  async init() {
    await this.refresh();

    await new Promise(r => setTimeout(r, 100));

    await this.read(0x23, []);
    await this.read(0x24, []);
    await this.read(0x27, []);
    await this.read(0x21, []);
    await this.read(0x9, [0]);

    await new Promise(r => setTimeout(r, 100));

    await this.read(0x3, []);
    await this.read(0x14, []);
  }

  async refresh() {
    if (this.connected) {
      await this.read(0x2, [0]);
      await this.read(0x1, [0]);
      await this.read(0xb, [0]);
      this.setConnected(+new Date());
    }
  }

  async refreshAll() {
    if (this.connected) {
      await this.read(0x2, [0]);
      await this.read(0x1, [0]);
      await this.read(0xb, [0]);

      await this.read(0x23, []);
      await this.read(0x24, []);
      await this.read(0x27, []);
      await this.read(0x21, []);
      await this.read(0x9, [0]);

      await this.read(0x3, []);
      await this.read(0x14, []);
      this.setConnected(+new Date());
    }
  }

  handleFrame = (value) => {
    const bytes = value instanceof DataView
      ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength)
      : value instanceof Uint8Array ? value : new Uint8Array(value);
    const frame = new Uint8Array(bytes);
    const merged = new DataView(frame.buffer);
    const msgType = getResponseCommand(merged);
    if (msgType === null) return;
    this.responses[msgType] = merged;
    if (this.responseCallback[msgType]) this.responseCallback[msgType](merged);
    this.setCommand({command: frame, direction: "<"});
  }

  handler = (e) => {
    const value = e.target.value;
    this.slices.push(...new Uint8Array(value.buffer, value.byteOffset, value.byteLength));

    while (this.slices.length >= 2) {
      const frameStart = this.slices.findIndex((byte, index) => (
        byte === 0xff && this.slices[index + 1] === 0x55
      ));
      if (frameStart < 0) {
        this.slices = this.slices.at(-1) === 0xff ? [0xff] : [];
        return;
      }
      if (frameStart > 0) this.slices.splice(0, frameStart);

      const frameEnd = this.slices.findIndex((byte, index) => (
        index >= 2 && byte === (responseTerminator >>> 8) && this.slices[index + 1] === (responseTerminator & 0xff)
      ));
      if (frameEnd < 0) return;

      const frame = this.slices.splice(0, frameEnd + 2);
      this.handleFrame(Uint8Array.from(frame));
    }
  }

  async connect(device= null) {
    if (!device) {
      device = await this.discovery();
    }
    this.device = device;
    device.addEventListener('gattserverdisconnected', () => {
      this.clearQueue();
      this.inQueue = false;
      this.disconnectionCallback();
    });
    this.gattService = await this.device.gatt.connect();
    this.service = await this.gattService.getPrimaryService(serviceUuid);
    this.characteristic = await this.service.getCharacteristic(characteristicUuid);
    this.characteristic2 = await this.service.getCharacteristic(characteristic2Uuid);
    this.characteristic2.addEventListener('characteristicvaluechanged', this.handler);
    await this.characteristic2.startNotifications();
    this.slices = [];
    this.responses = {};
    this.responseCallback = {};

    await this.init();
    return this;
  }

  async disconnect() {
    this.autoRefresh = false;
    this.clearQueue();
    this.inQueue = false;
    if (this.device?.gatt?.connected) this.device.gatt.disconnect();
  }
}
